export const banners = [{
  id: 1,
  img: require('@/assets/images/banner2.png')
},
{
  id: 2,
  img: require('@/assets/images/banner1.png')
}
];

export const menu = [{
  id: 'h_1',
  title: '首页',
  link: '/'
}, {
  id: 'p_1',
  title: '解决方案',
  isOpen: true,
  children: [{
    id: 'p_1_1',
    title: '方案',
    children: [{
      id: 'p_1_1_1',
      title: '教育领域',
      desc: 'AI580',
      link: '/'
    }, {
      id: 'p_1_1_2',
      title: '民生领域',
      desc: '',
      link: '/'
    }, {
      id: 'p_1_1_3',
      title: '政务领域',
      desc: '',
      link: '/'
    }, {
      id: 'p_1_1_4',
      title: '司法领域',
      desc: '',
      link: '/'
    }, {
      id: 'p_1_1_5',
      title: '其它领域',
      desc: '',
      link: '/'
    }]
  }, {
    id: 'p_1_2',
    title: '服务',
    children: [{
      id: 'p_1_3_1',
      title: '商业变现',
      desc: '产品服务交付及变现',
      link: '/ability/business'
    }, {
      id: 'p_1_3_2',
      title: '品牌营销',
      desc: '全渠道引流获客转化',
      link: '/ability/brand'
    }, {
      id: 'p_1_3_3',
      title: '用户运营',
      desc: '分类运营触达沉淀用户',
      link: '/ability/user'
    }]
  }]
}, {
  id: 'c_1',
  title: '公益计划',
  link: '/serviceWelfare'
}, {
  id: 'pr_1',
  title: '关于我们',
  link: '/introduce'
}, {
  id: 'ch_1',
  title: '加入我们',
  link: '/join'
}];

export const moduleChannel = [{
  title: '微信H5店铺',
  desc: '轻量级移动经营体验',
  desc2: '即开即用易传播',
  img: require('@/assets/images/scene.png'),
  icon: require('@/assets/images/icon_h5.png')
}, {
  title: '微信小程序',
  desc: '一键生成，无需开发',
  desc2: '快速拥有自己的小程序店铺',
  img: require('@/assets/images/scene2.png'),
  icon: require('@/assets/images/icon_minprogram.png')
}, {
  title: 'PC独立官网',
  desc: '具备产品交付和商业变现能力',
  desc2: '建立专属品牌官网',
  img: require('@/assets/images/scene3.png'),
  icon: require('@/assets/images/icon_pc.png')
}, {
  title: '知链助手APP',
  desc: '学员/讲师/商家都能用',
  desc2: '无需开发也能在APP上经营变现',
  img: require('@/assets/images/scene4.png'),
  icon: require('@/assets/images/icon_App.png')
}, {
  title: 'API/SDK开发',
  desc: '联接多个渠道',
  desc2: '打通自有APP实现个性化自主开发',
  img: require('@/assets/images/scene5.png'),
  icon: require('@/assets/images/icon_Api.png')
}];
